function rows(value) {
  return Array.isArray(value) ? value : [];
}

export function normalizeSalesImportDetail(response = {}) {
  const source = response?.data && !response.id ? response.data : response;
  const sales = source.sales || {};
  const stock = source.stock;
  const treasury = source.treasury;
  const salesPoints = rows(sales.pointsOfSale);
  const stockPoints = rows(stock?.pointsOfSale);
  const pointNames = [...new Set([...salesPoints, ...stockPoints]
    .map((point) => String(point?.pointOfSale || ""))
    .filter(Boolean))];

  return {
    id: Number(source.id),
    integratedAt: source.integratedAt || null,
    integratedBy: source.integratedBy || null,
    originalFileName: source.originalFileName || "",
    fileAvailable: source.fileAvailable === true,
    historicalDataAvailable: Boolean(stock && treasury),
    draft: {
      salesDateFrom: sales.salesDateFrom || "",
      salesDateTo: sales.salesDateTo || "",
      processedRows: sales.processedRows,
      distinctReceiptCount: sales.distinctReceiptCount,
      distinctProductCount: sales.distinctProductCount,
      totalUnitsSold: sales.totalUnitsSold,
      totalSalesAmount: sales.totalSalesAmount,
      pointsOfSale: pointNames,
    },
    preview: stock && treasury ? {
      descriptions: rows(stock.descriptions),
      consumption: rows(stock.consumption),
      shortages: rows(stock.regularizations),
      pointsOfSale: pointNames.map((pointOfSale) => ({
        pointOfSale,
        sales: salesPoints.find((point) => point.pointOfSale === pointOfSale)?.sales || null,
        stock: stockPoints.find((point) => point.pointOfSale === pointOfSale)?.stock || null,
      })),
      summary: { totalCmv: sales.totalCmv },
    } : null,
    treasury: treasury ? {
      ...treasury,
      totals: { distributed: treasury.totalDistributed },
    } : null,
  };
}
